import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

import { breakpoint } from '../../Grid';

export default styled.div`
  position: relative;
  display: none;
  grid-area: menu;
  line-height: 2rem;

  ${upTo(breakpoint)`
    display: grid;
  `}
`;
